export default function ({ context }) {
  const devUrl = 'https://gb.dev.gb.ru'
  const prodUrl = 'https://gb.ru'

  const baseUrl = context.$config.isProd ? prodUrl : devUrl

  return {
    async getBanner(bannerName) {
       try {
         return await context.$axios.get(`${baseUrl}/api/ui/v1/banners/${bannerName}`)
       } catch (e) {
         return null
       }
    },

    async getRandomBanner() {
      try {
        const params = {
          url: context.route.fullPath
        }

        return await context.$axios.get(`${baseUrl}/api/ui/v2/banners/random`, { params })
      } catch (e) {
        return null
      }
    },

    async getFeedbacks() {
      const params = {
        'page[size]': 50,
        minCountChar: 60,
        sort: '-createdAt'
      }

      try {
        return await context.$axios.get(`${baseUrl}/api/ui/v1/main/feedbacks`, { params })
      } catch (e) {
        return null
      }
    }
  }
}
